export default build =>
    build.mutation({
        query(payload) {
           // console.log("payload",payload)
            return {
                url: '/course/editCouponCode',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allCouponCodes'],
       
    })
